import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { VendorDto } from '../dto/vendor.dto';
import {
  QueryResult,
  QueryOptions,
  QueryResultItem,
} from '../components/common-dto/query.dto';

@Injectable({
  providedIn: 'root',
})
export class MockVendorService {
  private mockVendors: QueryResultItem<VendorDto>[] = [
    {
      id: '1',
      item: {
        name: 'Tech Solutions Inc.',
        contactEmail: 'contact@techsolutions.com',
        contactPhone: '402-555-1001',
        contactName: 'John Tech',
        description: 'Leading provider of enterprise software solutions',
        website: 'https://techsolutions.com',
        boothNumber: 'A101',
        createdAt: new Date('2024-12-01'),
        updatedAt: new Date('2024-12-01'),
      },
    },
    {
      id: '2',
      item: {
        name: 'Cloud Services Pro',
        contactEmail: 'info@cloudservicespro.com',
        contactPhone: '402-555-1002',
        contactName: 'Sarah Cloud',
        description: 'Cloud infrastructure and migration services',
        website: 'https://cloudservicespro.com',
        boothNumber: 'A102',
        createdAt: new Date('2024-12-02'),
        updatedAt: new Date('2024-12-02'),
      },
    },
    {
      id: '3',
      item: {
        name: 'Marketing Masters',
        contactEmail: 'hello@marketingmasters.com',
        contactPhone: '402-555-1003',
        contactName: 'Mike Marketing',
        description: 'Digital marketing and advertising solutions',
        website: 'https://marketingmasters.com',
        boothNumber: 'B201',
        createdAt: new Date('2024-12-03'),
        updatedAt: new Date('2024-12-03'),
      },
    },
    {
      id: '4',
      item: {
        name: 'Data Analytics Co.',
        contactEmail: 'contact@dataanalytics.com',
        contactPhone: '402-555-1004',
        contactName: 'Emily Data',
        description: 'Business intelligence and data analytics tools',
        website: 'https://dataanalytics.com',
        boothNumber: 'B202',
        createdAt: new Date('2024-12-04'),
        updatedAt: new Date('2024-12-04'),
      },
    },
    {
      id: '5',
      item: {
        name: 'Design Studio Pro',
        contactEmail: 'info@designstudiopro.com',
        contactPhone: '402-555-1005',
        contactName: 'Jessica Design',
        description: 'UI/UX design and creative services',
        website: 'https://designstudiopro.com',
        boothNumber: 'C301',
        createdAt: new Date('2024-12-05'),
        updatedAt: new Date('2024-12-05'),
      },
    },
    {
      id: '6',
      item: {
        name: 'Security Solutions',
        contactEmail: 'security@securitysolutions.com',
        contactPhone: '402-555-1006',
        contactName: 'Robert Security',
        description: 'Cybersecurity and data protection services',
        website: 'https://securitysolutions.com',
        boothNumber: 'C302',
        createdAt: new Date('2024-12-06'),
        updatedAt: new Date('2024-12-06'),
      },
    },
  ];

  constructor() {}

  getVendors(
    conferenceId: string,
    queryParams: QueryOptions
  ): Observable<QueryResult<VendorDto>> {
    let items = [...this.mockVendors];

    // Apply filter if provided
    if (queryParams.filter && queryParams.filter.trim() !== '') {
      const filterLower = queryParams.filter.toLowerCase();
      items = items.filter(
        (vendor) =>
          vendor.item.name?.toLowerCase().includes(filterLower) ||
          vendor.item.contactEmail?.toLowerCase().includes(filterLower) ||
          vendor.item.contactName?.toLowerCase().includes(filterLower) ||
          vendor.item.description?.toLowerCase().includes(filterLower) ||
          vendor.item.boothNumber?.toLowerCase().includes(filterLower)
      );
    }

    // Apply pagination
    if (queryParams.take && queryParams.skip !== undefined) {
      const skip = Number(queryParams.skip);
      const take = Number(queryParams.take);
      items = items.slice(skip, skip + take);
    }

    return of({
      items,
      total: this.mockVendors.length,
      take: queryParams.take || items.length,
      skip: queryParams.skip || 0,
    }).pipe(delay(300));
  }
}

